module.exports = __webpack_public_path__ + "static/media/w2.7b377864.png";